/**
 * @typedef {object} ElementAlignObject
 * @property {string} [horizontal] - How to horizontally align items
 * @property {string} [vertical] - How to vertically align items
 */

/**
 * @typedef {string|ElementAlignObject} ElementAlign
 *
 * This states how to align items.
 */
import { isObjectLiteral } from "../helpers/object-util.js";

export const centerAlign = "center";

export const topAlign = "top";

export const rightAlign = "right";

export const bottomAlign = "bottom";

export const leftAlign = "left";

export const baselineAlign = "baseline";

/**
 * Helper function that builds an align CSS class, and prepend the given prefix to it.
 * It is made to work with a `display: flex`.
 *
 * @param {string} prefix - Help discriminate the CSS class
 * @param {ElementAlign} align - Alignment strategy
 * @return {string}
 */
export function elementAlignCssClass(prefix, align) {
	if (isObjectLiteral(align)) {
		return [
			elementAlignCssClassForOneDirection(
				`${prefix}-horizontal`,
				align.horizontal,
			),
			elementAlignCssClassForOneDirection(
				`${prefix}-vertical`,
				align.vertical,
			),
		];
	}

	return elementAlignCssClassForOneDirection(prefix, align);
}

function elementAlignCssClassForOneDirection(prefix, align) {
	switch (align) {
		case centerAlign: {
			return `${prefix}-align-${centerAlign}`;
		}
		case baselineAlign: {
			return `${prefix}-align-${baselineAlign}`;
		}
		case bottomAlign: {
			return `${prefix}-align-${bottomAlign}`;
		}
		case rightAlign: {
			return `${prefix}-align-${rightAlign}`;
		}
		case topAlign: {
			return `${prefix}-align-${topAlign}`;
		}
		case leftAlign: {
			return `${prefix}-align-${leftAlign}`;
		}
		default: {
			return "";
		}
	}
}
